import LoadingBar from "react-redux-loading-bar";
import { Fragment } from "react";
import ReduxToastr from "react-redux-toastr";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import * as sentry from "@sentry/react";
import Modal from "components/modal/modal";
import View from "constants/view";
import LoadingBlocker from "components/loading-blocker/loading-blocker";
import Login from "components/login/login";
import Authenticate from "components/authenticate";
import { ServerErrorModal } from "shared/modal";

import AuthenticatedRoutes from "./authenticated-routes";
import StackingLayers from "./stacking-layers";
import ErrorFallback from "components-for/errors/error-fallback";

/**
 * Render all global components like the loading block, toastr etc. and all basic high-level routes like the login
 * screen. Most other routes require the user to be logged in so they are contained in another component.
 * @returns Various top-level components and routes.
 */
const Application = () => (
    <Fragment>
        <ReduxToastr
            preventDuplicates
            timeOut={2500}
            position="bottom-right"
            transitionIn="fadeIn"
            transitionOut="fadeOut"
        />
        <LoadingBar className="loading" />
        <Modal />

        <LoadingBlocker>
            {/* Render StackingLayers as a child of LoadingBlocker so loading blockers will work in modals */}
            <StackingLayers />
            <BrowserRouter>
                <Switch>
                    <Route path={View.Main}>
                        {({ history, location }) => (
                            <ServerErrorModal>
                                {(showServerError) => (
                                    <AuthenticatedRoutes
                                        pathname={location.pathname}
                                        push={history.push}
                                        showServerError={showServerError}
                                    />
                                )}
                            </ServerErrorModal>
                        )}
                    </Route>

                    <Route exact={true} path={View.Login}>
                        <ServerErrorModal>
                            {(showServerError) => <Login showServerError={showServerError} />}
                        </ServerErrorModal>
                    </Route>

                    <Route exact={true} path={View.Authenticate}>
                        {({ history, location }) => <Authenticate push={history.push} search={location.search} />}
                    </Route>
                </Switch>
            </BrowserRouter>
        </LoadingBlocker>
    </Fragment>
);

export default sentry.withErrorBoundary(Application, { fallback: ErrorFallback, showDialog: true });
